export const types = {
  GET_DEVICES: 'FORM/GET_DEVICES',
  SET_DEVICES: 'FORM/SET_DEVICES',
  GET_TRANSACTION: 'FORM/GET_TRANSACTION',
  SET_TRANSACTION: 'FORM/SET_TRANSACTION',
  SET_TRANSACTION_ERROR: 'FORM/SET_TRANSACTION_ERROR'
};

export const actions = {
  getDevices: (data) => ({
    type: types.GET_DEVICES,
    payload: { data },
  }),
  setDevices: (data) => ({
    type: types.SET_DEVICES,
    payload: { data },
  }),
  getTransaction: (data) => ({
    type: types.GET_TRANSACTION,
    payload: { data },
  }),
  setTransaction: (data) => ({
    type: types.SET_TRANSACTION,
    payload: { data },
  }),
  setTransactionError: (data) => ({
    type: types.SET_TRANSACTION_ERROR,
    payload: { data },
  }),
  
};

const initialState = {
  devices: null,
  searchingDevices: false,
  transactionData: null,
  isLoadingTransaction: false,
  transactionError: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.GET_DEVICES: {
      return {
        ...state,
        searchingDevices: true,
      };
    }
    case types.SET_DEVICES: {
      const { data } = { ...action.payload };
      const { devices = [] } = {
        ...data,
      };
      return {
        ...state,
        devices,
        searchingDevices: false,
      };
    }
    case types.GET_TRANSACTION: {
      return {
        ...state,
        isLoadingTransaction: true,
      };
    }
    case types.SET_TRANSACTION: {
      const { data = null } = action.payload;
      return {
        ...state,
        transactionData: data ? {...data} : null,
        isLoadingTransaction: false,
      };
    }
    case types.SET_TRANSACTION_ERROR: {
      const { data } = action.payload;
      const { title, description } = data;
      
      return {
        ...state,
        isLoadingTransaction: false,
        transactionError: {
          title,
          description,
        }
      };
    }
    default:
      return state;
  }
}

export default reducer;
